<h2 mat-dialog-title>{{data.titleText ?? 'Confirm deletion'}}</h2>

<mat-dialog-content>
	<p [innerHTML]="data.dialogText">	</p>
</mat-dialog-content>

<mat-dialog-actions>
	<button mat-button [mat-dialog-close]="false">{{data.noText ?? 'Cancel'}}</button>
	<button mat-button [mat-dialog-close]="true">{{data.yesText ?? 'Delete'}}</button>
</mat-dialog-actions>
